var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlastLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_137",
    "data-name": "\\uADF8\\uB8F9 137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_99",
    "data-name": "\\uC0AC\\uAC01\\uD615 99",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_136",
    "data-name": "\\uADF8\\uB8F9 136",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3853",
    "data-name": "\\uD328\\uC2A4 3853",
    d: "M420.491,215.4l-6.794-10a1.3,1.3,0,0,0-1.79-.362q-.051.033-.1.071l-.178.142a1.3,1.3,0,0,1-1.525.068,1.3,1.3,0,0,0-1.793.356q-.023.034-.043.068l-.339.568a1.294,1.294,0,0,1-1.121.639v18.92a1.3,1.3,0,0,0,.769-.251l12.6-8.411a1.321,1.321,0,0,0,.311-1.807",
    transform: "translate(-392.81 -197.865)",
    fill: "#b44321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3854",
    "data-name": "\\uD328\\uC2A4 3854",
    d: "M2.842,215.4l6.794-10a1.3,1.3,0,0,1,1.79-.362q.051.033.1.071l.178.142a1.3,1.3,0,0,0,1.525.068,1.3,1.3,0,0,1,1.793.356q.023.033.043.068l.339.568a1.294,1.294,0,0,0,1.121.639v18.92a1.3,1.3,0,0,1-.768-.251L3.153,217.2a1.321,1.321,0,0,1-.311-1.807",
    transform: "translate(-2.524 -197.865)",
    fill: "#fa6e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3855",
    "data-name": "\\uD328\\uC2A4 3855",
    d: "M13.195.258.565,7.543A1.342,1.342,0,0,0,.1,9.134l1.776,5.26,5.837-9A2.257,2.257,0,0,1,9.6,4.369a21.77,21.77,0,0,0,4.4.452V0a1.379,1.379,0,0,0-.8.258",
    transform: "translate(0 0)",
    fill: "#fa6e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3856",
    "data-name": "\\uD328\\uC2A4 3856",
    d: "M420.236,7.543,407.605.258A1.381,1.381,0,0,0,406.8,0V4.821a21.772,21.772,0,0,0,4.4-.452,2.257,2.257,0,0,1,1.895,1.023l5.837,9,1.776-5.26a1.342,1.342,0,0,0-.469-1.59",
    transform: "translate(-392.8 0)",
    fill: "#b44321"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlastLogo);
export default __webpack_public_path__ + "static/media/blast-logo.38b9d85c.svg";
export { ForwardRef as ReactComponent };